import { twMerge } from 'tailwind-merge';

const CardBodyMetrics = (props: any) => {
  const { data } = props;
  if (!data.metrics) return null;

  const hasQuotes = data.metrics.startsWith('"') || data.metrics.startsWith('“');
  const text = hasQuotes ? data.metrics.slice(1, -1) : data.metrics;

  return (
    <div
      data-testid="wid-product-card-metrics"
      className={twMerge(
        'h-[18px] box-border max-w-full px-100 bg-surface-100-bg text-surface-200-fg-minor enki-body-3xs-strong rounded-200 inline-flex items-center justify-center border border-solid border-surface-100-hairline',
        hasQuotes && '!font-normal'
      )}>
      <div className="flex leading-4 w-full items-center">
        {hasQuotes && '"'}
        <span className="inline-block overflow-hidden text-ellipsis whitespace-nowrap">{text}</span>
        {hasQuotes && '"'}
      </div>
    </div>
  );
};

export default CardBodyMetrics;
